import {LipoModelInterface} from "../../../shared/interfaces/lipo-model.interface";
import {ProductServiceModel} from "../../../product/services/models/product-service.model";
import {CustomerOverviewServiceModel} from "../../../customer/services/models/customer-service.model";
import {SystemOverviewServiceModel} from "../../../system/services/models/system-service.model";

export class PartnerDetailModel implements LipoModelInterface {
  constructor(
    public id: number | null = null,
    public name: string = '',
    public mail: string = '',
    public phone: string = '',
    public customers: CustomerOverviewServiceModel[] = [],
    public systems: SystemOverviewServiceModel[] = [],
    public products: ProductServiceModel[] = [],
    public logoUrl: string | null = null,
  ) {
  }

  getId(): number | null {
    return this.id;
  }
}
